import React from "react";
import styled from 'styled-components';
import PropTypes from 'prop-types';

var Videoplay = function Videoplay(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/React.createElement("svg", {
    className: className,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.6667 24L16 34.6667V13.3333L34.6667 24Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452\n       0 24C0 37.2548 10.7452 48 24 48ZM45.3333 24C45.3333 35.7821 35.7821 45.3333 24 45.3333C12.2179\n        45.3333 2.66667 35.7821 2.66667 24C2.66667 12.2179 12.2179 2.66667 24 2.66667C35.7821 2.66667\n         45.3333 12.2179 45.3333 24Z"
  }));
};

Videoplay.propTypes = {
  className: PropTypes.string
};
var IconVideoplay = styled(Videoplay).withConfig({
  displayName: "icon-video-play__IconVideoplay",
  componentId: "sc-1ugwcki-0"
})(["width:25px;height:25px;", ""], function (props) {
  return props.inverseColor ? "\n    path {\n      fill: black;\n    }\n  " : "\n    path {\n      fill: white;\n    }\n  ";
});
export default IconVideoplay;